import React, { useState } from 'react';
import Header from './Header';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';

import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';

const Myaccount = () => {
    const navigate = useNavigate();
    const { setCartData } = useCart();
    const user = JSON.parse(localStorage.getItem('user'));
    const [activeSection, setActiveSection] = useState('profile');

    // Edit Profile State
    const [formData, setFormData] = useState({
        firstName: user?.First_Name || '',
        lastName: user?.Last_Name || '',
        email: user?.Email || ''
    });

    // Change Password State
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
//show password
const [showCurrentPassword, setShowCurrentPassword] = useState(false);
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setCartData([]);
        navigate('/login');
    };

    const handleSaveProfile = async (e) => {
        e.preventDefault();

        // Debug: Check user data
        // console.log('Current user:', user);
        // console.log('Form data:', formData);

        if (!user.UserID) {
            alert('UserID not found. Please login again.');
            navigate('/login');
            return;
        }

        try {
            const requestBody = {
                UserID: user.UserID,
                First_Name: formData.firstName,
                Last_Name: formData.lastName,
                Email: formData.email
            };

            // console.log('Sending request:', requestBody);

            const response = await fetch(`${process.env.REACT_APP_SECRET_KEY}/api/updateuserprofile`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            // console.log('Response status:', response.status);
            // console.log('Response data:', data);

            if (response.ok) {
                // Update localStorage with new data
                const updatedUser = {
                    ...user,
                    First_Name: formData.firstName,
                    Last_Name: formData.lastName,
                    Email: formData.email
                };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                alert(data.message || 'Profile updated successfully!');
                window.location.reload();
            } else {
                alert(data.message || 'Failed to update profile');
            }
        } catch (error) {
            // console.error('Error updating profile:', error);
            alert('Network error. Please check if server is running.');
        }
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();

        // Validation
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            alert('New passwords do not match!');
            return;
        }
        if (passwordData.newPassword.length < 6) {
            alert('Password must be at least 6 characters!');
            return;
        }

        // Check if user is logged in
        if (!user.UserID) {
            alert('UserID not found. Please login again.');
            navigate('/login');
            return;
        }

        try {
            const requestBody = {
                UserID: user.UserID,
                oldPassword: passwordData.currentPassword,
                newPassword: passwordData.newPassword,
                confirmPassword: passwordData.confirmPassword
            };

            // console.log('Sending password change request:', requestBody);

            const response = await fetch(`${process.env.REACT_APP_SECRET_KEY}/api/changepassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            // console.log('Password change response:', data);

            if (response.ok) {
                alert(data.message || 'Password changed successfully!');
                // Clear password fields
                setPasswordData({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
                // Go back to profile view
                setActiveSection('profile');
            } else {
                alert(data.message || 'Failed to change password');
            }
        } catch (error) {
            // console.error('Error changing password:', error);
            alert('Network error. Please check if server is running.');
        }
    };

    if (!user) {
        return (
            <div className="account-empty-state">
                <p>Please log in to access your dashboard.</p>
                {/* <button onClick={() => navigate('/login')}>LOG IN</button> */}
            </div>
        );
    }

    return (
        <div className="account-page-wrapper">
             <style>{`
            input[type="password"]::-ms-reveal,
            input[type="password"]::-ms-clear {
                display: none !important;
            }
        `}</style>
            <Header />
            <div className="modern-account-container">
                {/* Sidebar / Profile Summary */}
                <div className="profile-sidebar">
                    <div className="user-avatar">
                        {user.First_Name.charAt(0)}{user.Last_Name.charAt(0)}
                    </div>
                    <h2 style={{ textAlign: "center", textTransform: "uppercase", letterSpacing: "2px" }}>
                        Hello, {user.First_Name}
                    </h2>
                    <p className="user-status">Verified Member</p>

                    <div className="sidebar-nav">
                        <button
                            className={`nav-btn ${activeSection === 'profile' ? 'active' : ''}`}
                            onClick={() => setActiveSection('profile')}
                        >
                            My Profile
                        </button>
                        <button
                            className={`nav-btn ${activeSection === 'edit' ? 'active' : ''}`}
                            onClick={() => setActiveSection('edit')}
                        >
                            Edit Profile
                        </button>
                        <button
                            className={`nav-btn ${activeSection === 'password' ? 'active' : ''}`}
                            onClick={() => setActiveSection('password')}
                        >
                            Change Password
                        </button>
                    </div>

                    <button className="logout-modern-btn" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt"></i> LOG OUT
                    </button>
                </div>

                {/* Main Content Area */}
                <div className="account-main-content">
                    {/* Profile View */}
                    {activeSection === 'profile' && (
                        <>
                            <div className="account-card-modern">
                                <h3>Personal Information</h3>
                                <div className="info-grid">
                                    <div className="info-item">
                                        <label>First Name</label>
                                        <div className="display-field">{user.First_Name}</div>
                                    </div>
                                    <div className="info-item">
                                        <label>Last Name</label>
                                        <div className="display-field">{user.Last_Name}</div>
                                    </div>
                                    <div className="info-item full-width">
                                        <label>Email Address</label>
                                        <div className="display-field">{user.Email || "user@example.com"}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="account-card-modern">
                                <h3>Quick Actions</h3>
                                <div className="actions-flex">
                                    <button className="action-link" onClick={() => setActiveSection('edit')}>
                                        Edit Profile
                                    </button>
                                    <button className="action-link" onClick={() => setActiveSection('password')}>
                                        Change Password
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Edit Profile */}
                    {activeSection === 'edit' && (
                        <div className="account-card-modern">
                            <h3>Edit Profile</h3>
                            <form className="profile-edit-form" onSubmit={handleSaveProfile}>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="firstName">First Name</label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            className="modern-input"
                                            value={formData.firstName}
                                            onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="lastName">Last Name</label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            className="modern-input"
                                            value={formData.lastName}
                                            onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="modern-input"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="form-actions">
                                    <button type="submit" className="save-btn">
                                        Save Changes
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-btn"
                                        onClick={() => {
                                            setFormData({
                                                firstName: user?.First_Name || '',
                                                lastName: user?.Last_Name || '',
                                                email: user?.Email || ''
                                            });
                                            setActiveSection('profile');
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Change Password */}
                    {activeSection === 'password' && (
                        <div className="account-card-modern">
                            <h3>Change Password</h3>
                            <form className="profile-edit-form" onSubmit={handleChangePassword}>
                                <div className="form-group">
                                    <label htmlFor="currentPassword">Current Password</label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showCurrentPassword ? "text" : "password"}
                                            id="currentPassword"
                                            className="modern-input"
                                            style={{ paddingRight: '40px', boxSizing: 'border-box', width: '100%' }}
                                            value={passwordData.currentPassword}
                                            onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                            style={{ position: 'absolute', right: '12px', top: '0', bottom: '0', margin: 'auto', height: '18px', cursor: 'pointer', fontSize: '18px', color: '#5a5a5a', display: 'flex', alignItems: 'center' }}
                                        >
                                            {showCurrentPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                        </span>
                                    </div>
                                </div>

                                {/* New Password */}
                                <div className="form-group">
                                    <label htmlFor="newPassword">New Password</label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showNewPassword ? "text" : "password"}
                                            id="newPassword"
                                            className="modern-input"
                                            style={{ paddingRight: '40px', boxSizing: 'border-box', width: '100%' }}
                                            value={passwordData.newPassword}
                                            onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
                                            required
                                            minLength="6"
                                        />
                                        <span
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            style={{ position: 'absolute', right: '12px', top: '0', bottom: '0', margin: 'auto', height: '18px', cursor: 'pointer', fontSize: '18px', color: '#5a5a5a', display: 'flex', alignItems: 'center' }}
                                        >
                                            {showNewPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                        </span>
                                    </div>
                                    <small className="password-hint">Minimum 6 characters required</small>
                                </div>

                                {/* Confirm Password */}
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm New Password</label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            id="confirmPassword"
                                            className="modern-input"
                                            style={{ paddingRight: '40px', boxSizing: 'border-box', width: '100%' }}
                                            value={passwordData.confirmPassword}
                                            onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            style={{ position: 'absolute', right: '12px', top: '0', bottom: '0', margin: 'auto', height: '18px', cursor: 'pointer', fontSize: '18px', color: '#5a5a5a', display: 'flex', alignItems: 'center' }}
                                        >
                                            {showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                        </span>
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="submit" className="save-btn">
                                        Update Password
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-btn"
                                        onClick={() => {
                                            setPasswordData({
                                                currentPassword: '',
                                                newPassword: '',
                                                confirmPassword: ''
                                            });
                                            setActiveSection('profile');
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Myaccount;